/* Ayudate · Tarjeta destacada de "Próxima sesión" (dashboard del tutor)
   Reutiliza la misma matemática de ventana que ya usa SalaJitsi.jsx
   (abre = inicio - minutosAntes) para no volver a hardcodear los "5
   minutos" en el cliente: ese número lo manda el servidor por sesión
   (ver obtenerDashboardTutor en apps-script.gs). Antes de que se abra la
   ventana muestra una cuenta regresiva; apenas se abre, se convierte en
   el acceso directo a la sala — mismo criterio de ventana que ya hace
   cumplir SalaJitsi.jsx del lado servidor, así que un clic antes de hora
   simplemente no puede pasar. */

import React, { useLayoutEffect, useState } from "react";

function formatearCuentaRegresiva(ms) {
  const totalMin = Math.max(0, Math.ceil(ms / 60000));
  if (totalMin >= 120) return `Inicia en ${Math.round(totalMin / 60)} horas`;
  if (totalMin >= 60) return `Inicia en 1 hora ${totalMin - 60} min`;
  if (totalMin >= 1) return `Inicia en ${totalMin} minutos`;
  return "Inicia en menos de un minuto";
}

export function ProximaSesion({ sesion, nombreCurso, textoFecha }) {
  const [faltaParaAbrir, setFaltaParaAbrir] = useState(null);

  // useLayoutEffect (no useEffect) para que el primer cálculo pinte antes
  // de que el navegador muestre el frame — mismo motivo que SalaJitsi.jsx.
  useLayoutEffect(() => {
    if (!sesion) return;
    const inicio = new Date(sesion.inicio);
    const minutosAntes = sesion.minutosAntes || 5;
    const abre = new Date(inicio.getTime() - minutosAntes * 60000);

    const tick = () => {
      const ahora = new Date();
      setFaltaParaAbrir(ahora < abre ? abre - ahora : 0);
    };

    tick();
    const id = setInterval(tick, 1000);
    return () => clearInterval(id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sesion]);

  if (!sesion) return null;
  const puedeEntrar = faltaParaAbrir === 0 && !!sesion.sala;

  return (
    <div className="proxima-sesion">
      <p className="proxima-sesion-eyebrow">Próxima sesión</p>
      <h2 className="proxima-sesion-curso">{nombreCurso}</h2>
      <p className="proxima-sesion-datos">{sesion.estudiante} · {textoFecha}</p>
      <div className="proxima-sesion-accion">
        {puedeEntrar ? (
          <a className="btn btn-p proxima-sesion-btn" href={sesion.sala}
            target="_blank" rel="noopener noreferrer">
            Entrar a la sala
          </a>
        ) : faltaParaAbrir !== null ? (
          <span className="proxima-sesion-cuenta">{formatearCuentaRegresiva(faltaParaAbrir)}</span>
        ) : null}
      </div>
    </div>
  );
}
